import { useParams } from "wouter";
import { useAuth } from "@/_core/hooks/useAuth";
import { getOrCreateDeviceId } from "@/lib/deviceId";
import { isPremiumApp } from "@shared/tiers";
import { usePaidSuite } from "@/components/EventSuiteAccess";
import { remainingLabel } from "@/lib/exportGate";
import { usageScope, useUsageSnapshot } from "@/lib/usageGate";
import { showDailyLimitPaywall } from "@/hooks/usePaywallDialog";

/** "N remaining today" next to export buttons; at 0 it also offers the pass. Renders nothing for paid, admin or unknown status. */
export function ExportUsageNote({ className = "", premiumOrZeroOnly = false }: { className?: string; /** Professional tools: only say anything when none are left. */ premiumOrZeroOnly?: boolean }) {
  const { isAuthenticated } = useAuth();
  const params = useParams<{ id?: string }>();
  const paid = usePaidSuite();
  useUsageSnapshot(); // re-render when the count changes
  const toolId = params.id ?? "unknown";
  const scope = usageScope(isAuthenticated, isAuthenticated ? undefined : getOrCreateDeviceId(), isPremiumApp(toolId));
  const label = paid ? null : remainingLabel(scope);
  if (!label) return null;
  const none = label.startsWith("0 ");
  if (premiumOrZeroOnly && !none && !isPremiumApp(toolId)) return null;
  return (
    <p className={`text-xs text-muted-foreground ${className}`} data-testid="export-remaining" role="status">
      {label}
      {none && (
        <>
          {" "}
          <button type="button" className="underline underline-offset-2 hover:text-foreground" onClick={() => showDailyLimitPaywall(toolId, "download")}>
            Get a Day Pass to download
          </button>
        </>
      )}
    </p>
  );
}
